// extracted by mini-css-extract-plugin
module.exports = {"products":"_s-z","misad":"at-z","oosMessaging":"bt-z","topProductFrame":"ct-z","productCardOverrides":"dt-z","secondRowAds":"et-z","microsoftAdsWrapper":"ft-z"};